import { Action, Tag, Text } from "@asurion-core/mx-asurion-ui-react";
import { DetailsContainer, DetailsWrapperContainer, HighlightText } from "@ubif/components";
import { isInventoryAvailable } from "@ubif/util-store";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { FlexContactWrapperContainer, FlexNameWrapperContainer } from "./FlexContainers";

type QuickSearchSerialProps = {
  itemName: string;
  itemNumber: string;
  serialNumber: string;
  highlightText: string;
  serialStatus: string;
  setShowModal: () => void;
};
export const QuickSearchSerialDetails = ({
  itemName,
  itemNumber,
  serialNumber,
  serialStatus,
  highlightText,
  setShowModal
}: QuickSearchSerialProps) => {
  const { t } = useTranslation("root-config");

  //create a function to handle the click event for opening the modal
  const handlePartModal = () => {
    setShowModal();
  };

  return (
    <StyledQuickSearchSerialDetails>
      <DetailsContainer>
        <FlexNameWrapperContainer>
          <HighlightText highlightText={highlightText} wholeText={itemName} />
          <HighlightText highlightText={highlightText} wholeText={itemNumber} />
        </FlexNameWrapperContainer>
        <FlexContactWrapperContainer>
          <Text color="#5D5E61">{serialNumber}</Text>
          <Tag text={serialStatus} type={isInventoryAvailable(serialStatus) ? "success" : "warn"} />
        </FlexContactWrapperContainer>
      </DetailsContainer>
      <ViewDetailButton size="md" variant="outline" onClick={() => handlePartModal()} style={{ marginRight: "1rem" }}>
        {t("GlobalSearch.ViewDetails")}
      </ViewDetailButton>
    </StyledQuickSearchSerialDetails>
  );
};

const StyledQuickSearchSerialDetails = styled(DetailsWrapperContainer)`
  background-color: var(--aui-elevated-level-01);
  color: var(--aui-on-surface);
  overflow: auto;
  &:hover {
    background-color: var(--aui-outline-soft);
    border-radius: 0.5rem;
    cursor: pointer;
  }
  display: flex;
`;

const ViewDetailButton = styled(Action)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
